<template>
    <div ref="container">
        <transition-group name="gmf-input-list" tag="div">
            <div v-for="(entry, index) in list" :key="entry.key" class="gmf-input-list-item">
                <DateInput :modelValue="entry.val" @update:modelValue="v => onUpdate(index, v)" :placeholder="placeholder" />
                <div class="gmf-input-list-remove" v-if="index < list.length - 1 || entry.val.length > 0"
                    @click="remove(index)">✕</div>
            </div>
        </transition-group>
    </div>
</template>
  
<style>

</style>

<script>
import DateInput from '@/components/input/DateInput.vue';

export default {
    props: ['modelValue', 'placeholder', 'maxItems'],
    components: {
        DateInput,
    },
    data () {
        let nextKey = 0;
        let list = [];
        if (this.modelValue) {
            for (const val of this.modelValue) {
                list.push({
                    key: nextKey++,
                    val,
                });
            }
        }
        if (list.length === 0 || list[list.length - 1].val.length > 0) {
            if (!this.maxItems || list.length < this.maxItems) {
                list.push({
                    key: nextKey++,
                    val: "",
                });
            }
        }
        return {
            nextKey,
            list,
        };
    },
    methods: {
        remove (index) {
            if (this.list.length === 1) {
                this.list[0].val = "";
                return;
            }
            this.list.splice(index, 1);
            this.emit();
        },
        emit() {
            this.$emit("update:modelValue", this.list.map(r => r.val).filter(Boolean));
        },
        onUpdate(index, value) {
            if (! value) {
                this.remove(index);
                return;
            }

            this.list[index].val = value;
            if (index >= this.list.length - 1) {
                if (!this.maxItems || this.list.length < this.maxItems) {
                    this.list.push({
                        key: this.nextKey++,
                        val: "",
                    });
                }
            }
            this.emit();
        }
    },
};
</script>
  